import { useMutation, useQueryClient } from 'react-query'
import { useErrorReporter } from 'Hooks/useErrorReporter'

import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { usePeoplePageContext } from 'Contexts/PeoplePageContext'

import { updateUserInformation } from 'Services/users/userService'

export const useUpdateUserInformation = () => {
  const reportError = useErrorReporter()
  const queryClient = useQueryClient()

  const { setModal, setActionableUserId } = usePeoplePageContext()

  return useMutation(updateUserInformation, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.UsersForEmployer])
        queryClient.invalidateQueries([QueryNames.UsersWithMetadata])
        toast.success(AppNotification.UserInformationUpdatedSuccessful)
        setModal(undefined)
        setActionableUserId(undefined)
      } else {
        toast.error(`${AppNotification.GenericFailure} ${response.message}`)
      }
    },
    onError: (err: string) => {
      reportError(`useUpdateUserInformation error: ${err}`)
    }
  })
}
